// extracted by mini-css-extract-plugin
export default {"menu":"Sidebar_menu__o4T7x"};